import React, { useCallback, useEffect, useState } from 'react';

const symbols = ['🦌', '🌲', '🎅', '❄️', '🧣', '🎿', '🧤', '⛄'];

function SlotDemo() {
  const [reelSymbols, setReelSymbols] = useState(['🍒', '🍋', '💎']);
  const [isSpinning, setIsSpinning] = useState(false);

  const spinSlots = useCallback(() => {
    if (isSpinning) return;
    setIsSpinning(true);

    let spins = 0;
    const maxSpins = 20;

    const interval = setInterval(() => {
      setReelSymbols([
        symbols[Math.floor(Math.random() * symbols.length)],
        symbols[Math.floor(Math.random() * symbols.length)],
        symbols[Math.floor(Math.random() * symbols.length)],
      ]);

      spins++;

      if (spins >= maxSpins) {
        clearInterval(interval);
        setIsSpinning(false);

        // Uduş yoxlaması
        setReelSymbols(currentSymbols => {
          if (currentSymbols[0] === currentSymbols[1] && currentSymbols[1] === currentSymbols[2]) {
            setTimeout(() => {
              alert('🎉 JACKPOT! 🎉\n(Remember: This is just for fun!)');
            }, 100);
          }
          return currentSymbols;
        });
      }
    }, 100);
  }, [isSpinning]);

  useEffect(() => {
    const timer = setTimeout(() => {
      spinSlots();
    }, 1000);

    return () => clearTimeout(timer);
  }, [spinSlots]); 

  return (
    <section className="slot-demo">
      <h2>👾 TRY OUR SLOTS 👾</h2>
      <div className="slot-machine">
        <div className="reels">
          <div className="reel" id="reel1">{reelSymbols[0]}</div>
          <div className="reel" id="reel2">{reelSymbols[1]}</div>
          <div className="reel" id="reel3">{reelSymbols[2]}</div>
        </div>
        <button className="spin-button" onClick={spinSlots} disabled={isSpinning}>
          SPIN!
        </button>
      </div>
    </section>
  );
}

export default SlotDemo;